import parse from './parse'
import stringify from './stringify'

export default {
  parse,
  stringify,
}
